import { PaymentMethod } from 'types/payments/payments';

export const BANK_CARD_CUSTOM_BUTTON_ID = 'customSubmitButton';

export const DAYS_PER_YEAR = 365;
export const DAYS_PER_MONTH = 31;
export const DAYS_PER_WEEK = 7;
export const DAYS_PER_TWO_MONTH = 1;
export const DAYS_PER_THREE_MONTH = 90;
export const DAYS_PER_FOUR_MONTH = 121;
export const DAYS_PER_FIVE_MONTH = 152;
export const DAYS_PER_SIX_MONTH = 182;
export const DAYS_PER_SEVEN_MONTH = 212;
export const DAYS_PER_EIGHT_MONTH = 243;
export const DAYS_PER_NINE_MONTH = 273;
export const DAYS_PER_TEN_MONTH = 304;
export const DAYS_PER_ELEVEN_MONTH = 334;
export const DAYS_PER_ONE_YEAR = 365;

export const APP_FULL_ACCESS = 'app_full_access';
export const VIP_SUPPORT = 'vip_support';

export interface IPaymentTypes {
    CREDIT_CARD: number;
    GOOGLE_PAY: number;
    PAYPAL: number;
    APPLE_PAY: number;
}

export const PAYMENT_TYPES: IPaymentTypes = {
    CREDIT_CARD: 1,
    GOOGLE_PAY: 1,
    PAYPAL: 4,
    APPLE_PAY: 1,
};

export const PAYMENT_TYPES_NAME = {
    CREDIT_CARD: 'Bank_Card',
    PAYPAL: 'PayPal',
    APPLE_PAY: 'apple_pay',
    GOOGLE_PAY: 'google_pay',
};

export const PAYMENT_METHOD_NAME = {
    1: 'Bank_Card',
    2: 'google_pay',
    3: 'ApplePay',
    4: 'PayPal',
};

export const PAYMENT_TYPES_NAME_ID = {
    CREDIT_CARD: 'bankCard',
    PAYPAL: 'payPal',
    APPLE_PAY: 'paymentGenerator',
    GOOGLE_PAY: 'paymentGenerator',
};

export const CREDIT_CARD_LITERAL = 'CREDIT_CARD';
export const PAYPAL_LITERAL = 'PAYPAL';
export const GOOGLE_PAY_LITERAL = 'GOOGLE_PAY';
export const APPLE_PAY_LITERAL = 'APPLE_PAY';

export const PRESELECTED_PAYMENT_TYPE: Record<string, PaymentMethod> = {
    apple_pay: APPLE_PAY_LITERAL,
    google_pay: GOOGLE_PAY_LITERAL,
    bank_card: CREDIT_CARD_LITERAL,
    paypal: PAYPAL_LITERAL,
};

export const PAYMENT_DEFAULT_CURRENCY = {
    sign: '$',
    name: 'USD',
};

export const EURO = {
    sign: '€',
    name: 'EUR',
};

export const GBP = {
    sign: '£',
    name: 'GBP',
};

export const DEVICE_OS = {
    ANDROID: 'ANDROID',
    IOS: 'IOS',
};

export const PAYMENT_FLOW_PERIODS = [
    DAYS_PER_MONTH,
    DAYS_PER_TWO_MONTH,
    DAYS_PER_THREE_MONTH,
    DAYS_PER_FOUR_MONTH,
    DAYS_PER_FIVE_MONTH,
    DAYS_PER_SIX_MONTH,
    DAYS_PER_SEVEN_MONTH,
    DAYS_PER_EIGHT_MONTH,
    DAYS_PER_NINE_MONTH,
    DAYS_PER_TEN_MONTH,
    DAYS_PER_ELEVEN_MONTH,
    DAYS_PER_YEAR,
    DAYS_PER_WEEK,
    DAYS_PER_ONE_YEAR,
];

// Introductory flow
export const INTRODUCTORY_A_FLOW_PAYMENT_ID = 'payment_Aa_checkout_Alpha1';
export const INTRODUCTORY_B_FLOW_PAYMENT_ID = 'payment_Ab_Checkout_Alpha1';

// 2.01 - Invalid Data
// 2.03 - Invalid Currency
// 2.05 - Order not Found
// 2.10 - Invalid 3DS flow on the merchant side
// 2.15 - SCA require 3D authentication
const SOLID_INVALID_DATA_CODES = ['2.01', '2.03', '2.05', '2.10', '2.15'];

// 5.02 - Invalid Card Token
// 5.03 - Application Error
// 5.04 - Merchant is not configured yet
// 5.05 - Merchant is not activated yet
const SOLID_PROCESSING_ERRORS_CODES = ['5.02', '5.03', '5.04', '5.05'];

// 7.01 - Card Token not found
// 7.02 - Google payment error
// 7.03 - Smart cascade decline
// 7.04 - 3DS cascade to 2D
// 7.05 - Apple online payment error
// 7.06 - Token generation error
const SOLID_DECLINED_PAYMENTS_CODES = ['7.01', '7.02', '7.03', '7.04', '7.05', '7.07'];

export const SOLID_ERROR_CODES = [
    ...SOLID_INVALID_DATA_CODES,
    ...SOLID_PROCESSING_ERRORS_CODES,
    ...SOLID_DECLINED_PAYMENTS_CODES,
];

export const MINIMUM_NUMBER_OF_PRODUCTS_TO_DISPLAY_THE_TIMER = 6;

export const LTV_COEFFICIENT_KEY = 'ltv_coef';

export const DEFAULT_LTV_COEFFICIENT = 1;
